// extracted by mini-css-extract-plugin
module.exports = {"recirculation":"recirculation_recirculation__OKiuy","darkTheme":"recirculation_darkTheme__EKKqY"};